/**
 * "Kind" of the menu post.
 *
 * @type {string}
 */
export const MENU_KIND = 'root';

/**
 * "post type" of the menu post.
 *
 * @type {string}
 */
export const MENU_POST_TYPE = 'menu';

/**
 * "Kind" of the navigation post.
 *
 * @type {string}
 */
export const NAVIGATION_POST_KIND = 'root';

/**
 * "post type" of the navigation post.
 *
 * @type {string}
 */
export const NAVIGATION_POST_POST_TYPE = 'navigationPost';

/**
 * The scope name of the editor's complementary area.
 *
 * @type {string}
 */
export const SIDEBAR_SCOPE = 'core/edit-navigation';

/**
 * The identifier of the editor's menu complementary area.
 *
 * @type {string}
 */
export const SIDEBAR_MENU = 'edit-navigation/menu';

/**
 * The identifier of the editor's block complementary area.
 *
 * @type {string}
 */
export const SIDEBAR_BLOCK = 'edit-navigation/block-inspector';

/**
 * The string identifier for the menu item's "target" attribute indicating
 * the menu item link should open in a new tab.
 *
 * @type {string}
 */
export const NEW_TAB_TARGET_ATTRIBUTE = '_blank';
